import {
  Box,
  Button,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { useContinueNavState } from 'modules/common';
import { CustomIcon } from 'modules/components/layer00';
import { RegisterForm } from 'modules/components/layer12';
import { useNavigate } from 'react-router-dom';



export type RegisterDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: RegisterDetailSectionProps) => {
  const state = useContinueNavState();
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Box>
      <Box
        display='flex'
        justifyContent='center'
        flexDirection='column'
        rowGap='2rem'
      >
        <RegisterForm.FC />
        <Stack
          direction='row'
          columnGap='.25rem'
          alignItems='center'
          justifyContent='space-around'
        >
          <Typography
            variant='bodyBold'
            paddingRight='.25rem'
            textTransform='none'
            sx={(theme) => ({
              [theme.breakpoints.down('md')]: {
                display: 'none'
              }
            })}
          >
            Already Have an account?
          </Typography>
          <Button
            onClick={() => navigate('../login', {
              state
            })}
            startIcon={(
              <CustomIcon.large.FC
                icon='LINK'
                stroke={theme.palette.primary.main}
              />
            )}
            variant='text'
            color='primary'
          >
            Sign in
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};
